<template>
  <div id="formulario-edit-info">   
    <ExibirErrosConcept :errorsValidacao="errorsValidacao" ref="errosComponent"></ExibirErrosConcept>
    <vs-prompt color="primary" :active.sync="popupDuplicar.popupActive" title="Duplicar Conta Múltiplas Vezes"     
      @accept="duplicarMultiploRequest"      
      :is-valid="popupDuplicar.quantidadeDuplicacao > 0 "
      acceptText="Duplicar" cancelText="Fechar">
       <div class="con-exemple-prompt">
            Informe o número de vezes que deseja duplicar:
            <vs-input v-model="popupDuplicar.quantidadeDuplicacao"/>         
       </div>
    </vs-prompt>

    <vs-popup title="Pagamento" :active.sync="popUpLancamento.popupActive">
        <vs-alert color="danger" :active.sync="popUpLancamento.exibirMensagem" closable icon-pack="feather" close-icon="icon-x" class="mb-3" icon="icon-info">
                {{popUpLancamento.mensagem}}
        </vs-alert> 
        <div id="div2-with-loading" class="vs-con-loading__container">
            <div class="flex w-full justify-center mb-2">                
                <vs-button type="border" class="ml-2" size="small" @click="gerarRecibo()" color="dark">RECIBO</vs-button>                            
            </div>
            <div class="vx-row mb-2">
                <div class="vx-col w-1/2">
                    <label class="vs-input--label" v-if="itemLancamento.hasOwnProperty('numeroLancamento')">Número</label>    
                    <h5 class="ml-3" v-if="itemLancamento.hasOwnProperty('numeroLancamento')">{{ itemLancamento.numeroLancamento }}</h5>
                </div>
                <div class="vx-col w-1/2">
                    <label class="vs-input--label" v-if="itemLancamento.hasOwnProperty('numeroLancamento')">Status</label>    
                    <h5 class="ml-3" v-if="itemLancamento.hasOwnProperty('status')">{{ itemLancamento.status }}</h5>
                </div>
            </div>        
            <div class="vx-row mb-2">
              <div class="vx-col w-1/4">
                    <label class="vs-input--label">Nota Fiscal</label>                        
                    <vs-input :disabled="isDesabilitarCampoLancamento" v-model="itemLancamento.nfeNumero"  class="w-full"/>
                </div>
            </div>
            <div class="vx-row mb-2">               
                <div class="vx-col w-full">
                    <label class="vs-input--label">Tipo</label>   
                    <v-select                                                                     
                        :options="CONSTANTE_TIPO_LANCAMENTO"  
                        :disabled="isDesabilitarCampoLancamento"                                               
                        :reduce="d => d.data"                 
                        v-model="itemLancamento.tipo"     
                        class="v-select w-full"
                    ></v-select>  
                </div>
            </div>   
            <div class="vx-row mb-2">               
                <div class="vx-col w-full">
                    <label class="vs-input--label">Pagar através de</label>   
                    <v-select          
                        label="nome"                                                 
                        :options="listaInstituicao"          
                        :disabled="isDesabilitarCampoLancamento"                                                        
                        v-model="itemLancamento.instituicao"                         
                        class="v-select w-full"></v-select> 
                </div>
            </div>             
            <div class="vx-row mb-2">               
                <div class="vx-col w-1/2">
                    <label class="vs-input--label">Data de Vencimento</label>           
                    <flat-pickr v-model="itemLancamento.data" class="mb-4 w-full" :config="configDatePicker" :disabled="isDesabilitarCampoLancamento" />                
                    </div>             
                <div class="vx-col w-1/2">
                    <label class="vs-input--label">Data de Pagamento</label>
                    <flat-pickr v-model="itemLancamento.dataEfetivacao" class="mb-4 w-full" :config="configDatePicker" :disabled="isDesabilitarCampoLancamento" />              
                    <div class="flex">
                        <vs-button class="mt-2" size="small" @click="copiarVencimento" color="primary" v-if="!isDesabilitarCampoLancamento">No Vencimento</vs-button>
                        <vs-button class="ml-auto mt-2" size="small" @click="setarDataEfetivacaoHoje" color="primary" v-if="!isDesabilitarCampoLancamento">Hoje</vs-button>
                    </div>
                </div> 
            </div>        
            <div class="vx-row mb-2">               
                <div class="vx-col w-1/2">
                    <label class="vs-input--label">Valor</label> 
                    <vue-autonumeric class="vs-inputx vs-input--input normal hasValue w-full" :disabled="isDesabilitarCampoLancamento" v-model="itemLancamento.valor" :options="[{emptyInputBehavior: 'null', digitGroupSeparator: '.', decimalCharacter: ',', minimumValue: '0', decimalPlaces:'2' }]"></vue-autonumeric>              
                </div>            
                <div class="vx-col w-1/2">
                    <label class="vs-input--label">Valor Pago</label>     
                    <vue-autonumeric class="vs-inputx vs-input--input normal hasValue w-full" :disabled="isDesabilitarCampoLancamento" v-model="itemLancamento.valorEfetivado" :options="[{emptyInputBehavior: 'null', digitGroupSeparator: '.', decimalCharacter: ',', minimumValue: '0', decimalPlaces:'2' }]"></vue-autonumeric>          
                    <vs-button class="mt-2" size="small" @click="copiarValor" color="primary" v-if="!isDesabilitarCampoLancamento">Mesmo que o Valor</vs-button>
                </div>            
            </div>
            <div class="vx-row">
                <div class="vx-col w-full">
                    <vs-textarea counter="1000" class="w-full mt-4" label="Complemento" v-model="itemLancamento.complemento" :disabled="isDesabilitarCampoLancamento"/>                
                </div>
                
            </div>       
            <div class="flex w-full">
                <vs-button class="ml-auto mt-2" size="small" @click="gravarLancamento('ABERTO')" color="success" v-if="itemLancamento.status !== 'EFETUADO' ">GRAVAR</vs-button>            
                <vs-button class="ml-auto mt-2" size="small" @click="gravarLancamentoLimpar('ABERTO')" color="success" v-if="!itemLancamento.hasOwnProperty('id')">GRAVAR E LIMPAR</vs-button>            
                <vs-button class="ml-2 mt-2" size="small" @click="gravarLancamento('EFETUADO')" color="primary" v-if="itemLancamento.status === 'ABERTO' ">EFETUAR</vs-button>            
                <vs-button class="ml-2 mt-2" size="small" @click="gravarLancamento('DESEFETUAR')" color="danger" v-if="itemLancamento.status === 'EFETUADO' && isGestor">DESEFETUAR</vs-button>            
                <vs-button class="ml-2 mt-2" size="small" @click="excluirLancamento" color="danger" v-if="itemLancamento.status === 'ABERTO' && isGestor ">EXCLUIR</vs-button>            
            </div>
        </div>
    </vs-popup>

    <vx-card>
        <div id="div-with-loading-conta" class="vs-con-loading__container">
            <div class="vx-row mb-4">
                <div class="vx-col w-2/3 ">                    
                    <vs-button class="ml-auto mt-2" size="small" type="border" color="dark" @click="voltar">Voltar</vs-button>     
                    <vs-button class="ml-4 mt-2" size="small" @click="gravar"        v-if="isExibirGravar" color="success">Gravar</vs-button>
                    <vs-button class="ml-4 mt-2" size="small" @click="gravarAprovar" v-if="isExibirGravarEAprovar" color="success">Gravar e Aprovar</vs-button>            
                    <vs-button class="ml-4 mt-2" size="small" @click="cancelar"       v-if="isExibirCancelar && isGestor" color="danger">Cancelar</vs-button>            
                    <vs-button class="ml-4 mt-2" size="small" @click="excluir"       v-if="isExibirExcluir" color="danger">Excluir</vs-button>            
                    <vs-button class="ml-4 mt-2" size="small" @click="duplicarMultiplo"      v-if="isExibirDuplicarMultiplo"   color="dark">Duplicar Múltiplo</vs-button>
                    <vs-button class="ml-4 mt-2" size="small" @click="duplicar"      v-if="isExibirDuplicar"   color="dark">Duplicar</vs-button>
                    <vs-button class="ml-4 mt-2" size="small" @click="aprovar"       v-if="isExibirAprovar" color="primary">Aprovar</vs-button>
                    <vs-button class="ml-4 mt-2" size="small" @click="desaprovar"    v-if="isExibirDesaprovar && isGestor" color="danger">Desaprovar</vs-button>                                            
                </div>
                <div class="vx-col w-1/6 items-center flex">                                    
                    Número: <h3 class="ml-2">{{data_local.numeroConta}}</h3>    
                </div>  
                <div class="vx-col w-1/6 items-center flex">                                    
                    <p class="ml-auto"> Status: </p> <h6 class="ml-2"> {{ data_local.status }}</h6>                     
                </div>                             
            </div>
            <div class="vx-row">            
                <div class="vx-col w-1/2"><label class="vs-input--label">Unidade Operacional</label></div>                 
                <div class="vx-col w-1/2"><label class="vs-input--label">Pagar Através de</label></div>                                                        
            </div>    
            <div class="vx-row">
                <div class="vx-col w-1/2 flex">
                    <v-select          
                        label="nome"                                                 
                        :options="listaUnidadeOperacional"                   
                        v-model="data_local.unidadeOperacional"     
                        :disabled="isDesabilitarCampo"  
                    class="v-select w-full"></v-select> 
                </div>          
                <div class="vx-col w-1/2 flex">
                    <v-select          
                        label="nome"                                                 
                        :options="listaInstituicao"                   
                        v-model="data_local.instituicao"     
                        :disabled="isDesabilitarCampo"  
                    class="v-select w-full"></v-select>    
                </div>              
            </div>    
            <div class="vx-row mt-3">
                <div class="vx-col w-1/2"><label class="vs-input--label">Plano de Conta</label></div>                             
                <div class="vx-col w-1/2"><label class="vs-input--label">Fornecedor</label></div>                             
            </div>    
            <div class="vx-row">
                <div class="vx-col w-1/2 flex">
                    <v-select          
                        label="nome"                                                 
                        :options="listaContaPlanoConta"                   
                        v-model="data_local.contaPlanoConta"     
                        :disabled="isDesabilitarCampo"  
                    class="v-select w-full"></v-select>   
                </div>                     
                <div class="vx-col w-1/2 flex">
                    <v-select          
                        label="nome"                                                 
                        :options="listaFavorecido"                   
                        v-model="data_local.favorecido"     
                        :filter="pesquisarFavorecido"         
                        :disabled="isDesabilitarCampo"  
                        class="v-select w-full">
                        <template v-slot:option="option">                        
                            <span style='font-family: Verdana, sans-serif;'> {{ option.nome }} </span> <br/> {{ option.cpfCNPJ }}  - {{ option.razaoSocial }}
                        </template>
                    </v-select>    
                </div>                     
            </div> 
            <div class="vx-row mt-3">
                <div class="vx-col w-1/3"><label class="vs-input--label">Vencimento</label></div>                                                     
                <div class="vx-col w-1/3 flex"><label class="vs-input--label">Valor </label> <small class="ml-auto">Saldo em aberto: R$ {{ saldoEmAbertoFormatado }}</small> </div>   
                <div class="vx-col w-1/3"><label class="vs-input--label">Forma de Pagamento</label></div>                                                                                                                                 
            </div>                    
            <div class="vx-row">
                <div class="vx-col w-1/3 flex">
                    <flat-pickr v-model="data_local.vencimento" class="mb-4 md:mb-0 w-full opacity-75" :config="configDatePicker" :disabled="isDesabilitarCampo"  />
                </div>                                             
                <div class="vx-col w-1/3">            
                    <vue-autonumeric class="vs-inputx vs-input--input normal hasValue" :disabled="isDesabilitarCampo" v-model="data_local.valor" :options="[{ digitGroupSeparator: '.', decimalCharacter: ',', minimumValue: '0', decimalPlaces:'2' }]"></vue-autonumeric>                 
                </div>
                <div class="vx-col w-1/3 flex">
                    <v-select                                                                     
                        :options="CONSTANTE_FORMA_PAGAMENTO"  
                        :reduce="d => d.data"                 
                        v-model="data_local.formaPagamento"     
                        :disabled="isDesabilitarCampo"  
                    class="v-select w-full"></v-select>    
                </div>    
            </div>   
            <div class="vx-row mt-3">                            
                <div class="vx-col w-1/3"><label class="vs-input--label">Nota Fiscal Recebida</label></div>                                        
                <div class="vx-col w-1/3"><label class="vs-input--label">Contrato/Recibo</label></div>                 
            </div>    
            <div class="vx-row">                        
                <div class="vx-col w-1/3 flex">
                    <vs-input class="w-full" v-model="data_local.numeroNotaFiscal" :disabled="isDesabilitarCampo" :maxlength="45"/>   
                </div>                  
                <div class="vx-col w-1/3 flex">
                    <vs-input class="w-full" v-model="data_local.contratoRecibo" :maxlength="45" :disabled="isDesabilitarCampo"/>   
                </div>                                          
            </div>            
            <div class="vx-row mt-3">
                <div class="vx-col w-1/2"><label class="vs-input--label">Complemento</label></div>     
            </div>
            <div class="vx-row">
                <div class="vx-col w-full">
                    <vs-textarea counter="4098" rows="6" class="w-full" v-model="data_local.complemento" :maxlength="4098" :disabled="isDesabilitarCampo"/> 
                </div>
            </div>

            <div class="vx-row mt-3" v-if="data_local.nomeArquivoAnexado">
                <div class="vx-col w-1/2"><label class="vs-input--label">Arquivo Anexo</label></div>     
            </div>
            <div class="vx-row" v-if="data_local.nomeArquivoAnexado">
                <div class="vx-col w-full">
                    <a :href='`https://sac.concept.inf.br/arquivosAnexos/${data_local.id}/${data_local.nomeArquivoAnexado}`' target="_blank"> {{data_local.nomeArquivoAnexado}} </a>
                </div>
            </div>

            <div class="vx-row" v-if="data_local.id">
                <div class="vx-col w-full">
                    <vs-row  class="mt-4"  vs-type="flex" vs-justify="space-between" vs-align="flex-start">     
                        <vs-col vs-type="flex" vs-align="flex-start" vs-w="3">
                            <file-upload
                                class="btn btn-primary w-full mr-3 mt-4"                                                        
                                :post-action="getUrlPost"                                                                                   
                                :multiple="false"
                                :data="dadosUpload"  
                                v-model="arquivosParaUpload"                             
                                ref="upload">
                                <i class="fa fa-plus"></i> Selecione o arquivo
                            </file-upload>
                        </vs-col>                               
                        <vs-col vs-type="flex" vs-w="8" v-if="arquivosParaUpload && arquivosParaUpload.length > 0">            
                            <vs-input class="w-full mr-2 mt-2" v-model="arquivosParaUpload[0].name" />                                                      
                        </vs-col>   
                        <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="1">            
                            <vs-button class="ml-1 mt-2" color="rgb(11, 189, 135)" type="filled" icon-pack="feather" icon="icon-upload" v-if="!$refs.upload || !$refs.upload.active" :disabled="arquivosParaUpload.length === 0 || $refs.upload.uploaded " @click.prevent="enviarArquivoUpload()"></vs-button>      
                        </vs-col>
                    </vs-row>      
                </div>
            </div>
            <div class="vx-row"  v-if="data_local.id && arquivosParaUpload && arquivosParaUpload[0] && arquivosParaUpload[0].success">
                <div class="vx-col w-full">             
                    <div class="op-block w-full" style="white-space: pre-line">{{exibirMensagelResultadoUpload(arquivosParaUpload[0].response)}}</div>
                </div>
            </div>      
          
        </div>
    </vx-card>  

    <vx-card class="mt-3" v-if="isExibirListaPagamentos">
        <h6> Pagamentos </h6>
        <div class="flex mb-2 mt-2">
            <vs-button size="small" class="nowrap" icon="search" color="primary" @click="fetchListaLancamentos()"></vs-button>             
            <vs-button size="small" class="nowrap ml-2" icon="add" color="primary" @click="novoLancamento()" v-if="this.data_local != null && this.data_local.status === 'ABERTA' && this.data_local.hasOwnProperty('id')"></vs-button>             
            <h5 class="ml-auto"> Total: {{valorTotalPagamentosFormatado}}</h5>
        </div>
        <div id="div-with-loading" class="vs-con-loading__container">
            <vs-table :data="listaLancamentos" noDataText="Nenhum Pagamento." stripe v-model="itemLancamento" @selected="editarLancamento">
                <template slot="thead">
                    <vs-th></vs-th>
                    <vs-th></vs-th>
                    <vs-th><small>Tipo</small></vs-th>                                
                    <vs-th><small>Número</small></vs-th>  
                    <vs-th><small>Nota Fiscal</small></vs-th>                                
                    <vs-th><small>Status</small></vs-th>                              
                    <vs-th><small>Vencimento</small></vs-th>
                    <vs-th><small>Pagamento</small></vs-th>
                    <vs-th><small>Valor</small></vs-th>
                    <vs-th><small>Valor Pago</small></vs-th>                
                    
                </template>
                <template slot-scope="{data}">
                    <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                        <vs-td>
                            <div class="btn-group flex">
                                <vs-button size="small" type="border" color="primary" icon-pack="feather" icon="icon-search"></vs-button>
                            </div>
                        </vs-td>
                        <vs-td :data="indextr">
                            <small>{{ (indextr + 1)}}</small>
                        </vs-td>
                        <vs-td :data="tr.tipo"><small> {{ tr.tipo }} </small></vs-td>
                        <vs-td :data="tr.numeroLancamento"> <small> {{ tr.numeroLancamento }} </small> </vs-td>
                        <vs-td :data="tr.nfeNumero"><small> {{ tr.nfeNumero }} </small> </vs-td>
                        <vs-td :data="tr.status"><small> {{ tr.status }} </small></vs-td>
                        <vs-td :data="tr.data"><small> {{ tr.dataFormatada }} </small></vs-td>
                        <vs-td :data="tr.dataEfetivacao"><small v-if="tr.dataEfetivacao"> {{ tr.dataEfetivacaoFormatada }} </small></vs-td>
                        <vs-td :data="tr.valor"><small> {{ formatarNumero(tr.valor) }} </small></vs-td>
                        <vs-td :data="tr.valorEfetivado"><small v-if="tr.valorEfetivado"> {{ formatarNumero(tr.valorEfetivado) }} </small></vs-td>
                       
                    </vs-tr>
                </template>
            </vs-table>
        </div>
    </vx-card>
  </div>
</template>

<script>
import generico from '@/generico.js'
import axios from "@/axios.js"
import VueAutonumeric from 'vue-autonumeric/src/components/VueAutonumeric.vue';
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import {Portuguese as PortugueseLocale} from 'flatpickr/dist/l10n/pt.js';
//import {english as EnglishLocale} from 'flatpickr/dist/l10n/default.js'
//import {Spanish as SpanishLocale} from 'flatpickr/dist/l10n/es.js'
import FileUpload from 'vue-upload-component'

const URL_SERVLET = "/Conta";
const NAME_ROUTE_SEARCH = "financeiro-contas-a-pagar-pesquisar";

import { CONSTANTE_FORMA_PAGAMENTO } from '@/constantesComboBox.js'
import { CONSTANTE_TIPO_LANCAMENTO } from  '@/constantesComboBox.js'

export default { 
  components: {  
    VueAutonumeric,
    flatPickr,
    FileUpload   
  },      
  props: {
    registroOriginal: {
      type: Object,
      required: false,
      default: function () {
        return { numeroConta: null, unidadeOperacional: null, contaPlanoConta: null, favorecido: null, vencimento: null, dataProgramadaEnvioAviso: null, valor: null, 
            formaPagamento: null, instituicao: null, numeroNotaFiscal: null, contratoRecibo: null, complemento: null, percentualDescontoPontualidade: null, 
            diasAntecedentesVencimentoParaDesconto: null, status: 'PROVISORIA', saldoEmAberto: 0 }
       }
    },
  },
  data() {
    return {        
        listaUnidadeOperacional: [],
        listaContaPlanoConta: [],
        listaFavorecido: [],
        listaInstituicao: [],
        listaLancamentos: [],
        errorsValidacao: [],  
        data_local: JSON.parse(JSON.stringify(this.registroOriginal)),     
        configDatePicker: {          
          altInput: true,
          altFormat: "d-m-Y",
          dateFormat: "Y-m-d", 
          altInputClass: "vs-inputx vs-input--input normal hasValue text-center",
          locale: PortugueseLocale
        },              
        popUpLancamento : {
            popupActive: false,
            exibirMensagem: false,
            mensagem: null
        }, 
        popupDuplicar: {
            popupActive: false,
            quantidadeDuplicacao: 0
        },
        itemLancamento: {tipo: 'NAO_INFORMADO', data: null, dataEfetivacao: null, valor: null, valorEfetivado: null, complemento: null, instituicao: null, nfeNumero: null },
        acceptArquivos: ['.ret', '.crt'],
        isArquivoProcessado: false,
        arquivosParaUpload: [],
        extensoesArquivos: ['ret', 'crt'],
        resultadoUploadKML: null,
        dadosUpload: {
            'idConta': null, 'nomeArquivo':null, 'idUsuario': String(this.$store.state.AppActiveUser.id)
        },
        isLimparItemLancamento: false
    }
  },  
  watch: {
    // UPDATE SUGGESTIONS LIST
    isArquivoProcessado(val) {
        if (val) {
            this.findById();
        }
    }
  },
  created(){
        this.CONSTANTE_FORMA_PAGAMENTO = CONSTANTE_FORMA_PAGAMENTO;           
        this.CONSTANTE_TIPO_LANCAMENTO = CONSTANTE_TIPO_LANCAMENTO;
  }, 
  mounted() {
    this.fetchListaUnidadeOperacional();
    this.fetchListaContaPlanoConta();
    this.fetchListaFavorecido();
    this.fetchListaInstituicao();      
    if (this.data_local != null && this.data_local.hasOwnProperty('id')) {
        this.findById();            
    } else {        
        this.data_local.formaPagamento = this.CONSTANTE_FORMA_PAGAMENTO[0].data;        
    }
  },
  computed: {   
    isGestor() {
		return (this.$store.state.AppActiveUser.perfil === 'GESTOR' || this.$store.state.AppActiveUser.perfil === 'GESTOR_EMPRESA');
	},   
    getUrlPost() {      
      return axios.defaults.baseURL  + "/File/upload";
    },
    isDesabilitarCampoLancamento(){
        return this.itemLancamento != null && this.itemLancamento.status === 'EFETUADO';
    },
    isExibirExcluir() {
       return this.data_local != null && ( this.data_local.status === 'PROVISORIA' || this.data_local.status === 'CANCELADA' ) && this.data_local.hasOwnProperty("id");
    },    
    isDesabilitarCampo(){
        return this.data_local != null && this.data_local.status !== 'PROVISORIA';
    },
    isExibirGravar(){
        return this.data_local != null && this.data_local.status === 'PROVISORIA';
    },
    isExibirGravarEAprovar(){
        return this.data_local != null && this.data_local.status === 'PROVISORIA' && !this.data_local.hasOwnProperty("id");
    },
    isExibirCancelar(){
        return this.data_local != null && this.data_local.status === 'ABERTA' && this.data_local.hasOwnProperty("id");
    },
    isExibirAprovar(){
       return this.data_local != null && this.data_local.status === 'PROVISORIA' && this.data_local.hasOwnProperty("id");
    },
    isExibirDesaprovar() {
        return this.data_local != null && this.data_local.status === 'ABERTA' && this.data_local.hasOwnProperty("id");
    },
    isExibirListaPagamentos(){
        return this.data_local != null && (this.data_local.status === 'ABERTA' || this.data_local.status === 'PAGA') && this.data_local.hasOwnProperty("id");
    },
    isExibirDuplicar(){
        return this.data_local != null && this.data_local.hasOwnProperty("id");
    },
    isExibirDuplicarMultiplo(){
        return this.data_local != null && this.data_local.hasOwnProperty("id") && ((this.$store.state.AppActiveUser.perfil === 'FINANCEIRO') ||
               (this.$store.state.AppActiveUser.perfil === 'GESTOR_EMPRESA') ||
               (this.$store.state.AppActiveUser.perfil === 'GESTOR'));
    },
    saldoEmAbertoFormatado(){
        return generico.formatarNumero(this.data_local.saldoEmAberto);
    },
    valorTotalPagamentos(){
        if (!this.listaLancamentos || this.listaLancamentos.length == 0) {
            return 0;
        }

        let lItem = null;
        let valorTotal = 0;
        for (var i=0; i < this.listaLancamentos.length; i++) {
            lItem = this.listaLancamentos[i];
            valorTotal = valorTotal + parseFloat(lItem.valor) ;                
        }

        return valorTotal;
    },    
    valorTotalPagamentosFormatado(){        
        return generico.formatarNumero(this.valorTotalPagamentos);        
    },

  },
  methods: {   
    enviarArquivoUpload(){     
        this.limparMsgErroUpload();                         
        this.isArquivoProcessado = false;
        this.dadosUpload.nomeArquivo = this.arquivosParaUpload[0].name;        
        this.dadosUpload.idConta = this.data_local.id;
        this.$refs.upload.update(this.arquivosParaUpload[0], { data: this.dadosUpload });
        this.$refs.upload.active = true;
        this.$vs.loading(); 
    },    
    exibirMensagelResultadoUpload(resposta) {
        this.$vs.loading.close();                
        if (resposta) {                        
            this.isArquivoProcessado = true;                                                                              
            return resposta;                
        }    

        return "Erro no processamento.";    
    },
    limparMsgErroUpload() {
      this.resultadoUploadKML = "";
    },  
    pesquisarFavorecido(options, varTermoPesquisa) {
        if (!varTermoPesquisa) {
            return;
        }
        varTermoPesquisa = varTermoPesquisa.toUpperCase();
        return options.filter(function (c) {
            return ( ( String(c.nome).toUpperCase().indexOf(varTermoPesquisa) != -1)  || (String(c.razaoSocial).toUpperCase().indexOf(varTermoPesquisa) != -1) || 
            ( String(c.cpfCNPJ).indexOf(varTermoPesquisa) != -1));
        })
    }, 
    setarDataEfetivacaoHoje() {
        var hoje = new Date();            
        this.itemLancamento.dataEfetivacao = hoje.toISOString().split('T')[0];
    },
    copiarVencimento(){
        this.itemLancamento.dataEfetivacao = this.itemLancamento.data;
    },
    copiarValor(){
        this.itemLancamento.valorEfetivado = this.itemLancamento.valor;
    },
    novoLancamento(){
        this.isLimparItemLancamento = false;
        this.itemLancamento = {tipo: 'NAO_INFORMADO', data: null, dataEfetivacao: null, valor: null, valorEfetivado: null, complemento: null, instituicao: null, nfeNumero: null };
        this.abrirPopUpItemLancamento();
    },
    editarLancamento(){
        this.isLimparItemLancamento = false;
        this.findLancamentoById();
        this.abrirPopUpItemLancamento();
    },
    abrirPopUpItemLancamento() {  
        if (!this.itemLancamento.hasOwnProperty('dataEfetivacao')) {
            this.$set(this.itemLancamento, 'dataEfetivacao', null);
        }
        if (!this.itemLancamento.hasOwnProperty('valorEfetivado')) {
            this.$set(this.itemLancamento, 'valorEfetivado', null);
        }
        if (!this.itemLancamento.hasOwnProperty('complemento')) {
            this.$set(this.itemLancamento, 'complemento', null);
        }
        
        this.popUpLancamento.mensagem = null;
        this.popUpLancamento.popupActive = true;
    },
    formatarNumero(valor) {
        return generico.formatarNumero(valor);
    },
    fetchListaUnidadeOperacional() {      
      const params = new URLSearchParams();      
      params.append('pagina',  -1);
      
      axios.post("/UnidadeOperacional/ListarUnidadeOperacional", params, {              
              credentials: 'include',
              responseEncoding: 'iso88591',
              withCredentials: true } )
      .then((response) => {
          if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {
              this.$router.push({ path: '/login' });
          } else {              
              this.listaUnidadeOperacional = response.data.Resultado.lista;              

              if (this.data_local != null && !this.data_local.hasOwnProperty("id") && this.listaUnidadeOperacional.length > 0) {
                    this.data_local.unidadeOperacional = this.listaUnidadeOperacional[0];
              }
              
          }
      })
      .catch((error) => { 
          /* eslint-disable no-console */  console.log("EFETUAR LOGOFF! - fetchListaUnidadeOperacional - " + error); 
      })                
    }, 
    fetchListaContaPlanoConta() {      
      const params = new URLSearchParams();      
      params.append('pagina',  -1);
      params.append('grupoPlanoConta.tipo',  'DESPESA');
      
      axios.post("/ContaPlanoConta/listar", params, {              
              credentials: 'include',
              responseEncoding: 'iso88591',
              withCredentials: true } )
      .then((response) => {
          if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {
              this.$router.push({ path: '/login' });
          } else {              
            this.listaContaPlanoConta = response.data.Resultado.lista;              
          }
      })
      .catch((error) => { 
          /* eslint-disable no-console */  console.log("EFETUAR LOGOFF! - fetchListaUnidadeOperacional - " + error); 
      })                
    }, 
    fetchListaFavorecido() {      
      const params = new URLSearchParams();      
      params.append('pagina',  -1);
      params.append('ehFornencedor',  true);
      
      axios.post("/Favorecido/ListarFavorecido", params, {              
              credentials: 'include',
              responseEncoding: 'iso88591',
              withCredentials: true } )
      .then((response) => {
          if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {
              this.$router.push({ path: '/login' });
          } else {              
            this.listaFavorecido = response.data.Resultado.lista;                            
          }
      })
      .catch((error) => { 
          /* eslint-disable no-console */  console.log("EFETUAR LOGOFF! - fetchListaUnidadeOperacional - " + error); 
      })                
    }, 
    fetchListaInstituicao() {      
      const params = new URLSearchParams();      
      params.append('pagina',  -1);
      params.append('funcaoInstituicao', 'CONTAS_A_PAGAR');
            
      axios.post("/Instituicao/listar", params, {              
              credentials: 'include',
              responseEncoding: 'iso88591',
              withCredentials: true } )
      .then((response) => {
          if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {
              this.$router.push({ path: '/login' });
          } else {              
              this.listaInstituicao = response.data.Resultado.lista;              

              if (this.data_local != null && !this.data_local.hasOwnProperty("id") && this.listaInstituicao.length > 0) {
                    this.data_local.instituicao = this.listaInstituicao[0];
              }
          }
      })
      .catch((error) => { 
          /* eslint-disable no-console */  console.log("EFETUAR LOGOFF! - fetchListaUnidadeOperacional - " + error); 
      })                
    }, 
    fetchListaLancamentos() {      
      
      this.$vs.loading({
        container: '#div-with-loading',
        scale: 0.6
      })
      
      const params = new URLSearchParams();      
      params.append('pagina',  -1);
      params.append('conta.id',  this.data_local.id);
                  
      axios.post("/Lancamento/ListarLancamento", params, {              
              credentials: 'include',
              responseEncoding: 'iso88591',
              withCredentials: true } )
      .then((response) => {
          this.$vs.loading.close('#div-with-loading > .con-vs-loading')
          if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {
              this.$router.push({ path: '/login' });
          } else {              
            this.listaLancamentos = response.data.Resultado.lista;              
          }
      })
      .catch((error) => { 
          this.$vs.loading.close('#div-with-loading > .con-vs-loading')
          /* eslint-disable no-console */  console.log("EFETUAR LOGOFF! - fetchListaUnidadeOperacional - " + error); 
      })     
      
    }, 
    findById() {
        this.$vs.loading({container: '#div-with-loading-conta', scale: 0.6});
        
        this.listaLancamentos = [];

        const params = new URLSearchParams();       
        params.append('empresa.id', this.$store.state.AppActiveUser.empresa.id);    
        params.append('id', this.data_local.id);           
                
        axios.post(URL_SERVLET + "/RecuperarConta", params, {              
                credentials: 'include', responseEncoding: 'iso88591', withCredentials: true } )
        .then((response) => {
            this.$vs.loading.close('#div-with-loading-conta > .con-vs-loading');
            if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {
                this.$router.push({ path: '/login' });
            } else {                
                this.data_local = response.data.Conta;   
                 
                if (this.data_local && this.data_local.hasOwnProperty('status') && this.data_local.status === 'ABERTA' || this.data_local.status === 'PAGA') {                    
                    this.fetchListaLancamentos();                
                }  
            }
        })
        .catch((error) => { 
            /* eslint-disable no-console */  console.log("EFETUAR LOGOFF! - findById - " + error); 
        })  
    }, 
    excluir() {
        this.$vs.dialog({
          type: 'confirm', color: 'warning', title: 'Atenção', text: 'Deseja excluir ?', acceptText: 'Sim', cancelText: 'Não', accept: this.excluirRequest
        });
    },
    excluirRequest() {
        this.$vs.loading();  
        const params = new URLSearchParams();                
        params.append('id', this.data_local.id);   
                
        axios.post(URL_SERVLET + "/RemoverConta", params, {              
                credentials: 'include', responseEncoding: 'iso88591', withCredentials: true } )
        .then((response) => {
            if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {
                this.$router.push({ path: '/' });
            } else {
                this.$vs.loading.close();
                if (response.data.toUpperCase().indexOf('SUCESSO') == -1) {
                        this.$vs.dialog({ color: 'danger', title: 'Erro', text: response.data, acceptText: 'OK'})
                } else {
                    this.$vs.notify({
                        title: "Mensagem", iconPack: 'feather', icon: 'icon-info', color: 'success',
                        text: response.data,
                    });
                    this.$router.push({ name: NAME_ROUTE_SEARCH })
                }                   
            }
        })
        .catch((error) => { 
            this.$vs.loading.close();
            /* eslint-disable no-console */ console.log("EFETUAR LOGOFF! - excluirRequest - " + error); 
        })  
    },    
    desaprovar(){
        this.$vs.dialog({
          type: 'confirm', color: 'warning', title: 'Atenção', text: 'Deseja Desaprovar a conta ?', acceptText: 'Sim', cancelText: 'Não', accept: this.desaprovarRequest
        });
    },
    desaprovarRequest(){
        this.submeter("/DesaprovarConta");
    },
    cancelar(){
        this.$vs.dialog({
          type: 'confirm', color: 'warning', title: 'Atenção', text: 'Deseja Cancelar a conta ?', acceptText: 'Sim', cancelText: 'Não', accept: this.cancelarRequest
        });
    },
    cancelarRequest(){
        this.submeter("/CancelarConta");
    },
    duplicar(){
        this.$vs.dialog({
          type: 'confirm', color: 'warning', title: 'Atenção', text: 'Deseja duplicar a conta ?', acceptText: 'Sim', cancelText: 'Não', accept: this.duplicarRequest
        });
    },
    duplicarRequest(){
        this.submeter("/DuplicarConta");
    },
    duplicarMultiplo(){
       this.popupDuplicar.popupActive = true;
       this.popupDuplicar.quantidadeDuplicacao = 0;
    },
    duplicarMultiploRequest(){
         this.$vs.loading();  
        const params = new URLSearchParams();                
        params.append('id', this.data_local.id);   
        params.append('quantidadeDuplicacao', this.popupDuplicar.quantidadeDuplicacao);   
                
        axios.post(URL_SERVLET + "/CriarContaMensalidades", params, {              
                credentials: 'include', responseEncoding: 'iso88591', withCredentials: true } )
        .then((response) => {
            if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {
                this.$router.push({ path: '/' });
            } else {
                this.$vs.loading.close();
                if (response.data.toUpperCase().indexOf('SUCESSO') == -1) {
                        this.$vs.dialog({ color: 'danger', title: 'Erro', text: response.data, acceptText: 'OK'})
                } else {
                    this.$vs.notify({
                        title: "Mensagem", iconPack: 'feather', icon: 'icon-info', color: 'success',
                        text: response.data,
                    });
                    this.$router.push({ name: NAME_ROUTE_SEARCH })
                }                   
            }
        })
        .catch((error) => { 
            this.$vs.loading.close();
            /* eslint-disable no-console */ console.log("EFETUAR LOGOFF! - duplicarRequest - " + error); 
        })          
    },
    aprovar(){
        this.$vs.dialog({
          type: 'confirm', color: 'warning', title: 'Atenção', text: 'Deseja Aprovar a conta ?', acceptText: 'Sim', cancelText: 'Não', accept: this.aprovarRequest
        });
    },
    aprovarRequest(){
        this.submeter("/AprovarConta");
    },
    gravarAprovar(){
        this.$vs.dialog({
          type: 'confirm', color: 'warning', title: 'Atenção', text: 'Deseja Inserir e Aprovar a conta ?', acceptText: 'Sim', cancelText: 'Não', accept: this.gravarAprovarRequest
        });
    },
    gravarAprovarRequest(){
        this.submeter("/InserirAprovarConta");
    },
    gravar() {
        this.$vs.dialog({
          type: 'confirm', color: 'warning', title: 'Atenção', text: 'Deseja gravar a conta ?', acceptText: 'Sim', cancelText: 'Não', accept: this.gravarRequest
        });
    },
    gravarRequest() {        
        this.submeter("/GravarConta");
    },
    submeter(urlPost) {        
        if (this.formularioValido()) { 
            this.$vs.loading();  
            const params = new URLSearchParams();    

            if (this.data_local.hasOwnProperty('id')) {
                params.append("id", this.data_local.id);
            }
            params.append("unidadeOperacional.id", this.data_local.unidadeOperacional.id);
            params.append("unidadeOperacional.nome", this.data_local.unidadeOperacional.nome);
            params.append("contaPlanoConta.id", this.data_local.contaPlanoConta.id);
            params.append("contaPlanoConta.nome", this.data_local.contaPlanoConta.nome);
            params.append("favorecido.id", this.data_local.favorecido.id);
            params.append("favorecido.nome", this.data_local.favorecido.nome);
            params.append("instituicao.id", this.data_local.instituicao.id);
            params.append("instituicao.nome", this.data_local.instituicao.nome);
            params.append("vencimento", this.data_local.vencimento);
            params.append("formaPagamento", this.data_local.formaPagamento);
            params.append("valor", this.data_local.valor);

            if (this.data_local.numeroConta) {
                params.append("numeroConta", this.data_local.numeroConta);
            }

            if (this.data_local.contratoRecibo) {
                params.append("contratoRecibo", this.data_local.contratoRecibo);
            }
            if (this.data_local.numeroNotaFiscal) {
                params.append("numeroNotaFiscal", this.data_local.numeroNotaFiscal);
            }
            if (this.data_local.complemento) {
                params.append("complemento", this.data_local.complemento);
            }

            axios.post(URL_SERVLET + urlPost, params, {              
                    credentials: 'include', responseEncoding: 'iso88591', withCredentials: true } )
            .then((response) => {
                this.$vs.loading.close();
                if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {
                    this.$router.push({ path: '/' });
                } else {                    
                    if (response.data.Conta.erroOperacao) {
                        this.$vs.dialog({ color: 'danger', title: 'Erro', text: response.data.Conta.mensagemResultadoOperacao, acceptText: 'OK'})
                    } else {                                                
                        this.$vs.notify({
                            title: "Mensagem", iconPack: 'feather', icon: 'icon-info', color: 'success',
                            text: response.data.Conta.mensagemResultadoOperacao,
                        });

                        this.data_local = response.data.Conta;  
                        this.findById();
                    }                   
                }
            })
            .catch((error) => { 
                this.$vs.loading.close();
                /* eslint-disable no-console */ console.log("EFETUAR LOGOFF! - gravar - " + error); 
            })  
        }
         
    },
    voltar() {
        this.$router.push({
            name: NAME_ROUTE_SEARCH                     
        })
    },
    formularioValido() {
        this.$refs.errosComponent.iniciar();
        this.errorsValidacao = [];
    
        if (!this.data_local.unidadeOperacional) { this.errorsValidacao.push("UNidade Operacional obrigatório"); }
        if (!this.data_local.contaPlanoConta) { this.errorsValidacao.push("Plano de Conta obrigatório"); }
        if (!this.data_local.favorecido) { this.errorsValidacao.push("Fornecedor obrigatório"); }
        if (!this.data_local.vencimento) { this.errorsValidacao.push("Vencimento obrigatório"); }
        if (!this.data_local.valor) { this.errorsValidacao.push("Valor obrigatório"); }
        if (!this.data_local.formaPagamento) { this.errorsValidacao.push("Forma de Pagamento obrigatório"); }
        if (!this.data_local.instituicao) { this.errorsValidacao.push("Instituição obrigatório"); }
    
        if (!this.errorsValidacao.length) {
            return true;
        }   
        return false;
    },
    findLancamentoById() {        
        this.$vs.loading({
            container: '#div2-with-loading',
            scale: 0.6
        })
        const params = new URLSearchParams();       
        params.append('empresa.id', this.$store.state.AppActiveUser.empresa.id);    
        params.append('id', this.itemLancamento.id);           
                
        axios.post("/Lancamento/RecuperarLancamento", params, {              
                credentials: 'include', responseEncoding: 'iso88591', withCredentials: true } )
        .then((response) => {
            this.$vs.loading.close('#div2-with-loading > .con-vs-loading')
            if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {
                this.$router.push({ path: '/login' });
            } else {                
                this.itemLancamento = response.data.Lancamento;   
                if (!this.itemLancamento.hasOwnProperty('dataEfetivacao')) {
                    this.$set(this.itemLancamento, 'dataEfetivacao', null);
                }
                if (!this.itemLancamento.hasOwnProperty('valorEfetivado')) {
                    this.$set(this.itemLancamento, 'valorEfetivado', null);
                }
                if (!this.itemLancamento.hasOwnProperty('complemento')) {
                    this.$set(this.itemLancamento, 'complemento', null);
                }                             
            }
        })
        .catch((error) => { 
            this.$vs.loading.close('#div2-with-loading > .con-vs-loading')
            /* eslint-disable no-console */  console.log("EFETUAR LOGOFF! - findById - " + error); 
        })  
    }, 
    formularioValidoItemLancamento() {
        if (!this.itemLancamento.tipo) {
            this.popUpLancamento.mensagem = "Informe o tipo do pagamento";
            this.popUpLancamento.exibirMensagem = true;
            return false;
        }
        if (!this.itemLancamento.instituicao || !this.itemLancamento.instituicao.id) {
            this.popUpLancamento.mensagem = "Informe através de qual instantuição será feito o pagamento";
            this.popUpLancamento.exibirMensagem = true;
            return false;
        }

        if (!this.itemLancamento.data) {
            this.popUpLancamento.mensagem = "Informe a data de vencimento do pagamento";
            this.popUpLancamento.exibirMensagem = true;
            return false;
        }

        if (!this.itemLancamento.valor) {
            this.popUpLancamento.mensagem = "Informe o valor do pagamento";
            this.popUpLancamento.exibirMensagem = true;
            return false;
        }
        return true;
    },
    formularioValidoItemLancamentoEfetivacao() {
        if ("NAO_INFORMADO" === this.itemLancamento.tipo) {
            this.popUpLancamento.mensagem = "Informe o tipo do pagamento";
            this.popUpLancamento.exibirMensagem = true;
            return false;
        }
        if (!this.itemLancamento.dataEfetivacao) {
            this.popUpLancamento.mensagem = "Informe a data do pagamento";
            this.popUpLancamento.exibirMensagem = true;
            return false;
        }

        if (!this.itemLancamento.valorEfetivado) {
            this.popUpLancamento.mensagem = "Informe o valor pago";
            this.popUpLancamento.exibirMensagem = true;
            return false;
        }

        return true;
    },
    gravarLancamentoLimpar(statusLancamento) {
        this.isLimparItemLancamento = true;
        this.gravarLancamento(statusLancamento);
    },
    gravarLancamento(statusLancamento) {
        if (statusLancamento === 'EFETUADO' && !this.formularioValidoItemLancamentoEfetivacao()) {
            return;
        }

        if (this.formularioValidoItemLancamento()) { 
            this.$vs.loading();  
            const params = new URLSearchParams();    
            
            if (this.itemLancamento.hasOwnProperty('id')) {
                params.append("id", this.itemLancamento.id);
            }

            params.append("tipo", this.itemLancamento.tipo);
            if (this.itemLancamento.numeroLancamento) {
                params.append("numeroLancamento", this.itemLancamento.numeroLancamento);
            }

            params.append("data", this.itemLancamento.data);
            if (this.itemLancamento.dataEfetivacao) {
                params.append("dataEfetivacao", this.itemLancamento.dataEfetivacao);
            }
            params.append("valor", this.itemLancamento.valor);

            if (this.itemLancamento.valorEfetivado) {
                params.append("valorEfetivado", this.itemLancamento.valorEfetivado);
            }
            if (this.itemLancamento.complemento) {
                params.append("complemento", this.itemLancamento.complemento);
            }
            
            params.append("conta.id", this.data_local.id);
            params.append("instituicao.id", this.itemLancamento.instituicao.id);
            params.append("unidadeOperacional.id", this.data_local.unidadeOperacional.id);
            params.append("status", statusLancamento);

            if (this.itemLancamento.nfeNumero) {
                params.append("nfeNumero", this.itemLancamento.nfeNumero);
            }
            
            axios.post("/Lancamento/GravarLancamento", params, {              
                    credentials: 'include', responseEncoding: 'iso88591', withCredentials: true } )
            .then((response) => {
                this.$vs.loading.close();
                if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {
                    this.$router.push({ path: '/' });
                } else {                    
                    if (response.data.Lancamento.erroOperacao) {
                        this.popUpLancamento.mensagem = response.data.Lancamento.mensagemResultadoOperacao;
                        this.popUpLancamento.exibirMensagem = true;                        
                    } else {                                                
                        this.$vs.notify({
                            title: "Mensagem", iconPack: 'feather', icon: 'icon-info', color: 'success',
                            text: response.data.Lancamento.mensagemResultadoOperacao,
                        });
                        
                        if(this.isLimparItemLancamento) {
                            this.itemLancamento.data = null;
                            this.itemLancamento.dataEfetivacao = null;
                            this.itemLancamento.valor = null
                            this.itemLancamento.valorEfetivado = null;
                            this.itemLancamento.complemento = null;
                            this.itemLancamento.nfeNumero = null;    
                            this.isLimparItemLancamento = false;
                        } else {
                            this.itemLancamento = response.data.Lancamento;      
                        }
                                                
                        if (statusLancamento === "EFETUADO") {
                            this.popUpLancamento.popupActive = false;
                            this.findById();                            
                        } else if (statusLancamento === "DESEFETUAR") {                            
                            this.findById();                            
                        } else {
                            this.fetchListaLancamentos();                            
                        }
                    }                   
                }
            })
            .catch((error) => { 
                this.$vs.loading.close();
                /* eslint-disable no-console */ console.log("EFETUAR LOGOFF! - gravar - " + error); 
            })  
        }        
    },
    excluirLancamento() {
        this.$vs.dialog({
          type: 'confirm', color: 'warning', title: 'Atenção', text: 'Deseja excluir o pagamento ?', acceptText: 'Sim', cancelText: 'Não', accept: this.excluirLancamentoRequest
        });
    },
    excluirLancamentoRequest() {
        this.$vs.loading();  
        const params = new URLSearchParams();                
        params.append('id', this.itemLancamento.id);   
                
        axios.post("/Lancamento/RemoverLancamento", params, {              
                credentials: 'include', responseEncoding: 'iso88591', withCredentials: true } )
        .then((response) => {
            if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {
                this.$router.push({ path: '/' });
            } else {
                this.$vs.loading.close();
                if (response.data.toUpperCase().indexOf('ERRO') != -1) {
                        this.$vs.dialog({ color: 'danger', title: 'Erro', text: response.data, acceptText: 'OK'})
                } else {
                    this.$vs.notify({
                        title: "Mensagem", iconPack: 'feather', icon: 'icon-info', color: 'success',
                        text: response.data,
                    });
                    this.fetchListaLancamentos();
                }                   
            }
        })
        .catch((error) => { 
            this.$vs.loading.close();
            /* eslint-disable no-console */ console.log("EFETUAR LOGOFF! - excluirRequest - " + error); 
        })  
    },  
    gerarRecibo(){
        let nomeFavorecidoTratado = this.data_local.favorecido.nome .replace(/[^a-zA-Z0-9 ]/g, '').replace(/ /g,"_");
        this.gerar("Lancamento/ExibirReciboFornecedor", "RECIBO_" + this.itemLancamento.numeroLancamento + "_" + nomeFavorecidoTratado);
    }, 
    gerar(urlGeracao, nomeArquivo) {        
                
                this.$vs.loading();
                const params = new URLSearchParams();                
                params.append('id', this.itemLancamento.id);        
                        
                axios.post(urlGeracao, params, {              
                        timeout: 600000, credentials: 'include', responseEncoding: 'iso88591', withCredentials: true,  responseType: 'arraybuffer' } )
                .then((response) => {
                    this.$vs.loading.close();
                    if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {                
                          this.$router.push({ path: '/login' });  // Efetuar logoff
                    } else {                                                                
                        var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                        var fileLink = document.createElement('a');
                        fileLink.href = fileURL;
                        fileLink.setAttribute('download', nomeArquivo + '.pdf');
                        document.body.appendChild(fileLink);
                        fileLink.click();                
                    }
                })
                .catch((error) => { 
                    /* eslint-disable no-console */  console.log("EFETUAR LOGOFF! - gravar - " + error); 
                    this.$vs.loading.close();
                }) 
            }, 
  }
}
</script>

<style scoped>
  .tabelaComScroll {      
      overflow: auto;  
      height: calc(100vh - 300px);
      position: relative;      
    } 
</style>


